import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComboboxItem, useComboboxContext } from '@ariakit/react';
import { forwardRef } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../../../const/colors/staticColors';
import { useGetTestIdAttribute } from '../../../../hooks/useTestIdAttribute';
import { HorizontalDivider } from '../../../HorizontalDivider/HorizontalDivider';
import { Text } from '../../../Text/Text';
import { Box } from '../../../layout/Box';
import { FlexContainer } from '../../../layout/FlexContainer';
const StyledComboboxItem = styled(ComboboxItem, ({ $isActive }) => ({
    cursor: 'pointer',
    userSelect: 'none',
    backgroundColor: $isActive
        ? staticColors.selectItemActiveBackgroundColor
        : undefined,
    ':focus-visible': {
        outline: 'none',
        backgroundColor: staticColors.selectItemActiveBackgroundColor,
    },
}));
export const ComboboxInputItem = forwardRef(({ testId, value, id = value, text, withDivider, subtext, onSelect }, ref) => {
    const comboboxContext = useComboboxContext();
    const activeId = comboboxContext?.useState('activeId');
    const isActive = id === activeId;
    const getTestIdAttribute = useGetTestIdAttribute();
    const testIdAttribute = getTestIdAttribute(testId);
    const onClick = () => {
        onSelect?.(value, id);
    };
    return (_jsx(StyledComboboxItem, { ref: ref, ...testIdAttribute, $isActive: isActive, value: value, id: id, focusOnHover: true, onClick: onClick, children: _jsxs(Box, { spacingHorizontal: true, spacingTop: true, children: [_jsxs(FlexContainer, { direction: 'column', children: [_jsx(Text, { variant: 's2', align: 'start', overflow: 'hidden', textOverflow: 'ellipsis', children: text }), subtext && (_jsx(Text, { variant: 'b3', align: 'start', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre-line', children: subtext }))] }), _jsx(Box, { spacingTop: true }), withDivider && _jsx(HorizontalDivider, {})] }) }));
});
